
export const QuizzView = () => {
    return(
        <>
        
        </>
    )
}